var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',{staticClass:"nav-header"},[_vm._v("致趣百川")])}
var staticRenderFns = []

export { render, staticRenderFns }